import { useEffect } from "react";
import { getSelectedListIdFromHtml } from "../utils/index";

export const useEditorScrollbarInteractions = ({
  editComponent,
  setLayerCompData,
  layerCompData,
  setScrollbarItems,
  selectedComponent,
  setSelectedComponent,
  setUpdatedValue,
  tempLayerScrollbarItems,
  scrollbarItems,
  setisReferenceFootnotesScrollbar,
  setCanvasScrollHeight,
  canvasDimension,
  setEditComponent,
  callOnResizeStop,
  updateFontOnResize,
}) => {
  const getScrollbarItems = (id) => {
    const scrollbarComp = layerCompData.find(
      (comp) => comp.componentType === "Scrollbar" && comp.id === id,
    );

    if (scrollbarComp) {
      setScrollbarItems(scrollbarComp.scrollbarComponents);
    }
  };

  const handleScrollbarComponentsDrag = (
    d,
    dragComponent,
    scrollbarContainerHeight,
    scrollbarContainerWidth,
    scrollbarComps,
  ) => {
    if (!editComponent) {
      return;
    }
    const tempScrollbarItems = [...scrollbarComps];
    const index = tempScrollbarItems.findIndex(
      (item) => item.id === dragComponent.id,
    );
    if (d.x < 0) {
      d.x = 0;
    }
    if (d.y > scrollbarContainerHeight - dragComponent.height) {
      d.y = scrollbarContainerHeight - dragComponent.height;
    }
    if (d.x > scrollbarContainerWidth - dragComponent.componentStyles.width) {
      d.x = scrollbarContainerWidth - dragComponent.componentStyles.width;
    }
    if (d.y < 0) {
      d.y = 0;
    }
    if (tempScrollbarItems[index]?.componentStyles) {
      tempScrollbarItems[index].componentStyles.left = d.x;
      tempScrollbarItems[index].componentStyles.top = d.y;
    }
  };

  const handleScrollbarComponentsDragStop = (
    d,
    dragComponent,
    scrollbarContainerHeight,
    scrollbarContainerWidth,
    scrollbarComps,
  ) => {
    if (!editComponent) {
      return;
    }
    const tempScrollbarItems = [...scrollbarComps];
    const index = tempScrollbarItems.findIndex(
      (item) => item.id === dragComponent.id,
    );
    if (d.x < 0) {
      d.x = 0;
    }
    if (d.y < 0) {
      d.y = 0;
    }
    if (d.y > scrollbarContainerHeight - dragComponent.componentStyles.height) {
      d.y = scrollbarContainerHeight - dragComponent.componentStyles.height;
    }
    if (d.x > scrollbarContainerWidth - dragComponent.componentStyles.width) {
      d.x = scrollbarContainerWidth - dragComponent.componentStyles.width;
    }
    if (tempScrollbarItems[index]?.componentStyles) {
      tempScrollbarItems[index].componentStyles.left = d.x;
      tempScrollbarItems[index].componentStyles.top = d.y;
    }
    setSelectedComponent(tempScrollbarItems[index]);
    setUpdatedValue((prevState) => ({
      ...prevState,
      componentStyles: {
        ...prevState.componentStyles,
        left: tempScrollbarItems[index].componentStyles.left,
        top: tempScrollbarItems[index].componentStyles.top,
      },
    }));
  };

  const handleTextChangeInScrollComp = (text, index, id, scrollbarComps) => {
    if (!editComponent) {
      return;
    }
    let data = [...scrollbarComps];
    data[index].froalaText = text;
    if (data[index]?.componentStyles) {
      data[index].componentStyles.selectedIdnumberList =
        getSelectedListIdFromHtml(text);
    }
    if (data[index].componentStyles.expandAndClose) {
      data[index].componentStyles.expandClose.expandHeight =
        document.getElementById("expandClose" + data[index].id)?.clientHeight ||
        data[index].componentStyles.expandClose.expandHeight;
    }
    setLayerCompData((prevData) =>
      prevData.map((comp) =>
        comp.componentType === "Scrollbar" && comp.id === id
          ? {
              ...comp,
              scrollbarComponents: data,
            }
          : comp,
      ),
    );
  };

  const handleCallonResizeStop = (
    component,
    scrollbarContainerHeight,
    scrollbarContainerWidth,
    scrollbarItemsList,
  ) => {
    if (!editComponent) {
      return;
    }
    let { id, height, width, x, y } = component;
    const tempScrollbarItems = [...scrollbarItemsList];
    const index = tempScrollbarItems.findIndex((item) => item.id === id);
    tempScrollbarItems[index].componentStyles.height = height;
    tempScrollbarItems[index].componentStyles.width = width;

    if (height + y > scrollbarContainerHeight) {
      height = Math.abs(scrollbarContainerHeight - y);
    }
    if (width + x > scrollbarContainerWidth) {
      width = Math.abs(scrollbarContainerWidth - x);
    }
    if (
      y >
      scrollbarContainerHeight -
        tempScrollbarItems[index].componentStyles.height
    ) {
      y =
        scrollbarContainerHeight -
        tempScrollbarItems[index].componentStyles.height;
    }
    if (
      x >
      scrollbarContainerWidth - tempScrollbarItems[index].componentStyles.width
    ) {
      x =
        scrollbarContainerWidth -
        tempScrollbarItems[index].componentStyles.width;
    }
    if (x < 0) {
      x = 0;
    }
    if (y < 0) {
      y = 0;
    }
    if (tempScrollbarItems[index]?.componentStyles) {
      tempScrollbarItems[index].componentStyles.left = x;
      tempScrollbarItems[index].componentStyles.top = y;
      tempScrollbarItems[index].componentStyles.height = height;
      tempScrollbarItems[index].componentStyles.width = width;
    }
    setUpdatedValue((prevState) => ({
      ...prevState,
      componentStyles: {
        ...prevState.componentStyles,
        left: tempScrollbarItems[index].componentStyles.left,
        top: tempScrollbarItems[index].componentStyles.top,
        height: tempScrollbarItems[index].componentStyles.height,
        width: tempScrollbarItems[index].componentStyles.width,
      },
    }));
    setSelectedComponent(tempScrollbarItems[index]);
  };

  const handleCallonResize = (
    component,
    scrollbarContainerHeight,
    scrollbarContainerWidth,
    scrollbarComps,
  ) => {
    if (!editComponent) {
      return;
    }
    let { id, height, width, x, y } = component;
    const tempScrollbarItems = [...scrollbarComps];
    const index = tempScrollbarItems.findIndex((item) => item.id === id);
    tempScrollbarItems[index].componentStyles.height = height;
    tempScrollbarItems[index].componentStyles.width = width;

    if (
      y >
      scrollbarContainerHeight -
        tempScrollbarItems[index].componentStyles.height
    ) {
      y =
        scrollbarContainerHeight -
        tempScrollbarItems[index].componentStyles.height;
    }
    if (
      x >
      scrollbarContainerWidth - tempScrollbarItems[index].componentStyles.width
    ) {
      x =
        scrollbarContainerWidth -
        tempScrollbarItems[index].componentStyles.width;
    }
    if (x < 0) {
      x = 0;
    }
    if (y < 0) {
      y = 0;
    }
    if (tempScrollbarItems[index]?.componentStyles) {
      tempScrollbarItems[index].componentStyles.left = x;
      tempScrollbarItems[index].componentStyles.top = y;
      tempScrollbarItems[index].componentStyles.height = height;
      tempScrollbarItems[index].componentStyles.width = width;
    }
  };

  const isScrollbarRhsEnable = () => {
    if (!editComponent) return true;

    const type = selectedComponent?.componentType;
    // Inside a scrollbar, only show RHS props when a nested child is selected.
    // Empty `{}` is truthy, so check componentType rather than the object itself.
    if (!type || type === "Scrollbar" || type === "default") {
      return false;
    }

    return true;
  };

  const onScrollbarComponentResizeStop = (items, ref, position) => {
    if (editComponent?.id === items.id) {
      setCanvasScrollHeight(
        editComponent &&
          editComponent?.componentStyles.scrollbarHeight +
            editComponent?.componentStyles.top >
            canvasDimension.height
          ? editComponent?.componentStyles.scrollbarHeight +
              editComponent?.componentStyles.top +
              100
          : "",
      );
      setLayerCompData((prevData) =>
        prevData.map((comp) =>
          comp.componentType === "Scrollbar" && comp.id === items.id
            ? {
                ...comp,
                componentStyles: {
                  ...comp.componentStyles,
                  scrollbarHeight:
                    ref.offsetHeight < items?.componentStyles.height
                      ? items?.componentStyles.height
                      : ref.offsetHeight,
                },
              }
            : comp,
        ),
      );
      setEditComponent((prev) => ({
        ...prev,
        componentStyles: {
          ...prev.componentStyles,
          scrollbarHeight:
            ref.offsetHeight < items?.componentStyles?.height
              ? items?.componentStyles?.height
              : ref.offsetHeight,
        },
      }));
    } else {
      if (ref.offsetHeight > items.componentStyles.scrollbarHeight) {
        setLayerCompData((prevData) =>
          prevData.map((comp) =>
            comp.componentType === "Scrollbar" && comp.id === items.id
              ? {
                  ...comp,
                  componentStyles: {
                    ...comp.componentStyles,
                    scrollbarHeight:
                      ref.offsetHeight < items?.componentStyles.height
                        ? items?.componentStyles.height
                        : ref.offsetHeight,
                  },
                }
              : comp,
          ),
        );
      }
      callOnResizeStop({
        id: items.id,
        width: ref.offsetWidth,
        height: ref.offsetHeight,
        x: position.x - (parseInt(items.componentStyles.translateX) || 0),
        y: position.y - (parseInt(items.componentStyles.translateY) || 0),
      });
    }
  };

  const onScrollbarComponentsResize = (items, ref, position) => {
    if (editComponent?.id === items.id) {
      setLayerCompData((prevData) =>
        prevData.map((comp) =>
          comp.componentType === "Scrollbar" && comp.id === items.id
            ? {
                ...comp,
                componentStyles: {
                  ...comp.componentStyles,
                  scrollbarHeight:
                    ref.offsetHeight < items?.componentStyles.height
                      ? items?.componentStyles.height
                      : ref.offsetHeight,
                },
              }
            : comp,
        ),
      );
    } else {
      updateFontOnResize({
        id: items.id,
        width: ref.offsetWidth,
        height: ref.offsetHeight,
        x: position.x - (parseInt(items.componentStyles.translateX) || 0),
        y: position.y - (parseInt(items.componentStyles.translateY) || 0),
      });
    }
  };

  useEffect(() => {
    if (editComponent?.id) {
      setLayerCompData((prevData) =>
        prevData.map((comp) =>
          comp.componentType === "Scrollbar" && comp.id === editComponent?.id
            ? { ...comp, scrollbarComponents: scrollbarItems }
            : comp,
        ),
      );
      tempLayerScrollbarItems.current = scrollbarItems;
      const isRefFootScrollbar = scrollbarItems?.some(
        (scrollbar) =>
          scrollbar.textComponentType.addContent === "Reference" ||
          scrollbar.textComponentType.addContent === "Footnotes",
      );
      setisReferenceFootnotesScrollbar(isRefFootScrollbar);
    }
  }, [scrollbarItems]);

  useEffect(() => {
    setCanvasScrollHeight(
      editComponent &&
        editComponent?.componentStyles.scrollbarHeight +
          editComponent?.componentStyles.top >
          canvasDimension.height
        ? editComponent?.componentStyles.scrollbarHeight +
            editComponent?.componentStyles.top +
            150
        : "",
    );
  }, [editComponent]);

  return {
    getScrollbarItems,
    handleScrollbarComponentsDrag,
    handleScrollbarComponentsDragStop,
    handleTextChangeInScrollComp,
    handleCallonResizeStop,
    handleCallonResize,
    isScrollbarRhsEnable,
    onScrollbarComponentResizeStop,
    onScrollbarComponentsResize,
  };
};
